import React, { useEffect, useState, useCallback } from "react";
import classes from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../components/icon/iconfont";
import { BlackMask } from "../../../../components/mask";
import { useQuery } from "../../../../hooks/common";
import { useSelector } from "react-redux";
import { getCountryMessage } from "../../../../../api";
import ReactDOM from "react-dom";
import Cache from "../../../../../utils/cache";

const BottomStyle1 = props =>{
    const { bottomBanner, onClose } = props;
    const { backgroundImage } = bottomBanner;

    useEffect(() =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELExpose', {
                clicks:"middle-coupon",
            })
        }
    }, []);

    const handleClose = () =>{
        onClose();

        Cache.set('bottom-banner', 1)

        if(window.GeekoSensors){
            window.GeekoSensors.Track('CloseCoupon', {
                clicks:"middle-coupon-1",
            })
        }
    }

    const handleBottomClick = useCallback((e, b) => {
        e.preventDefault();
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks:"middle-coupon",
            })
        }

        if(b.isLogin){
            window.location.href = `/i/login?redirectUrl=${encodeURIComponent(window.location.href)}`
        }else if(b.href){
            window.location.href = b.href
        }
    }, [])

    return <React.Fragment>
        <div className={classes.AlertDiscount}>
            <a 
                onClick={(e)=>handleBottomClick(e, bottomBanner)}
                className={classes.AlertHref} 
                href={bottomBanner?.href}
            >
                <img src={backgroundImage?.url} />
            </a>
            <Iconfont className={classes.Close} onClick={handleClose}>&#xe69a;</Iconfont>
        </div>

        <BlackMask onClick={handleClose} />
    </React.Fragment>
}

const BottomBannerTip = props =>{
    useStyles(classes);
    const [bottomBanner, setBottomBanner] = useState(null);
    const query = useQuery();
    const global = useSelector(state=>state.global);

    useEffect(async () =>{
        // if(query.utm_source && query.utm_source != "traffic"){
        //     Cache.remove('has-utmsource');
        // }

        const shouldShow = !!!Cache.get('bottom-banner');
        // const canShowBottom = !!Cache.get('has-utmsource');
        // if(((query?.utm_source == "traffic") || canShowBottom) && shouldShow && !global?.user?.id){
        if(shouldShow && !global?.user?.id){
            let response = await getCountryMessage("M1817");
            if(response?.code === 200 && response?.result){
                // const data = global?.abTest == "A" ? response.result?.style2 : response.result?.style1;
                setBottomBanner(response.result?.style2);

                // 作为utm_source来过的标记
                // Cache.set('has-utmsource', true, 24*60*60*365);
            }
        }
    }, []);

    return <React.Fragment>
        {
            !!bottomBanner && ReactDOM.createPortal(<React.Fragment>
                <BottomStyle1 {...props} bottomBanner={bottomBanner} onClose={()=>setBottomBanner(null)} />
            </React.Fragment>, typeof document !== 'undefined' ? document.getElementById('root') : null)
        }
    </React.Fragment>
}

export default BottomBannerTip;